import { BlogAxios } from './../../NetworkHelper';
import endpoints from 'libs/src/config/endpoints';

export const fetchAllMedia = async (
  pageNumber = 1,
  size = 100,
): Promise<any> => {
  try {
    let data = await BlogAxios.get(
      `/api${endpoints.media}&pagination[page]=${pageNumber}&pagination[pageSize]=${size}&sort=DateCreated:DESC`,
    );
    return data;
  } catch (error) {
    return [];
  }
};
